import { Button, ButtonProps } from '../common/Button';
import { InfoCircle } from '../common/icons';

export default function GoalAssumptionsInfoLink(props: ButtonProps) {
    return (
        <Button
            variant="link"
            rightIcon={<InfoCircle size="sm" />}
            color="textMuted"
            size="sm"
            fontWeight="normal"
            {...props}
        />
    );
}
